// The gig domain model now lives in the shared package (consumed by both the app and Cloud
// Functions). This file re-exports it, and keeps the talent-dashboard composites below, which are
// client-side only — the dashboard builds them in the browser from the parent event doc; they are
// never stored on gig docs. New code may import from '@otm/shared/gig' directly.
import { Gig } from '@otm/shared/gig';
import { FlexDetailsField, Venue, AttireByTag } from './event';
import { EntType } from './config';

export * from '@otm/shared/gig';

export interface DashboardEventData {
  dateStart: Date | null;
  eventTitle: string;
  attire: string;
  attireByContactTag?: AttireByTag[];
  timeStart?: Date | null;
  timeEnd?: Date | null;
  eventType: EntType;
  venue?: Venue;
  avTech?: string;
  flexDetailsFields: FlexDetailsField[];
  staticDetailsFields: {
    [key: string]: string;
  };
}

export type DashboardGig = DashboardEventData & Gig;

export const dashboardEventDataInit: DashboardEventData = {
  dateStart: null,
  eventTitle: '',
  attire: '',
  attireByContactTag: [],
  timeStart: null,
  timeEnd: null,
  eventType: {
    id: '',
    name: '',
    color: ''
  },
  staticDetailsFields: {},
  flexDetailsFields: []
};
